const map = {
	"./address.js": 76181,
	"./annotation.js": 11315,
	"./attachment.js": 54004,
	"./charge.js": 35293,
	"./correction-round.js": 19380,
	"./draft.js": 43042,
	"./follower.js": 1755,
	"./invitation.js": 73682,
	"./invoice.js": 11325,
	"./orders.js": 50384,
	"./organization.js": 83934,
	"./preview.js": 75161,
	"./problem.js": 778,
	"./project-item.js": 81034,
	"./project.js": 65200,
	"./sales-order.js": 62360,
	"./services.js": 95305,
	"./session.js": 36089,
	"./transaction.js": 6369,
	"./user.js": 40910,
	"utils/api/translators/address.js": 76181,
	"utils/api/translators/annotation.js": 11315,
	"utils/api/translators/attachment.js": 54004,
	"utils/api/translators/charge.js": 35293,
	"utils/api/translators/correction-round.js": 19380,
	"utils/api/translators/draft.js": 43042,
	"utils/api/translators/follower.js": 1755,
	"utils/api/translators/invitation.js": 73682,
	"utils/api/translators/invoice.js": 11325,
	"utils/api/translators/orders.js": 50384,
	"utils/api/translators/organization.js": 83934,
	"utils/api/translators/preview.js": 75161,
	"utils/api/translators/problem.js": 778,
	"utils/api/translators/project-item.js": 81034,
	"utils/api/translators/project.js": 65200,
	"utils/api/translators/sales-order.js": 62360,
	"utils/api/translators/services.js": 95305,
	"utils/api/translators/session.js": 36089,
	"utils/api/translators/transaction.js": 6369,
	"utils/api/translators/user.js": 40910
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33278;